import React from 'react';
import {Button, withStyles,} from '@material-ui/core';
import ToolbarButtonGroup from "../../../../../helpers/ToolbarButtonGroup";
import {Slide} from "@mui/material";
import {colorGridStyles, getColor} from "./results/colorUtils";
import LoadingCircle from "../../../../util/common/LoadingCircle";

const styles = {
  ...colorGridStyles,
  response:{
    margin: "0 auto",
  },
  responseText:{
    textAlign: "center",
    fontWeight: 300,
    margin: "0.5rem 0"
  },
  button: {
    flex: 1,
    position: "relative"
  },
  options:{
    display: "flex",
    justifyContent: "center"
  },
  selected:{
    outline: "2px solid #4446"
  },
  optionsLabels:{
    position: "relative",
    fontSize: "0.7225rem",
    fontWeight: 700,
    '& > td':{
      textAlign: "center",
      verticalAlign: "top",
    },
    '& > td:first-child':{
      textAlign: "left",
      width: "0px"
    },
    '& > td:last-child':{
      textAlign: "right",
      width: "0px"
    },
  },
  midTd:{
    position: "absolute",
    width: "100%",
    left: "0px"
  },
  loadingWrap:{
    position: "absolute",
    display: "flex",
    top: 0,
    left: 0,
    width: "100%",
    height: "100%",
    alignItems: "center",
    justifyContent: "center",
  },
  loader:{
    padding: 0,
  },
}
function AnswerSelect(props) {
  const { slideIn, slideDirection, question, colorClass, answerOpts, labelMin, labelMid, labelMax, value, setVal, saving, setHover=()=>{}, classes } = props;
  const answerRange = answerOpts.length

  const mid = Math.floor(answerRange/2)
  const even = answerRange % 2 === 0
  const body =
    <div className={classes.response}>
      <div className={classes.responseText}><span id={"instructions"}>{question}</span></div>
      <div className={classes.options}>
        <table id={"answerMenu"}>
          <tbody>
          <tr>
            <td colSpan={answerRange}>
              <ToolbarButtonGroup
                style={{flexWrap: "nowrap"}}
                onMouseLeave={() => setHover(null)}
              >
                {new Array(answerRange).fill(0).map((_, i) => {
                  const colI = Math.round(((!even ? i - mid : i >= mid ? i - mid  + 1 : i - mid) / mid) * 4) + 4;
                  const ansVal = answerOpts[i].value;
                  return <Button
                      key={`${colorClass}_${i}`}
                      className={`${classes.button} ${value === ansVal ? classes.selected : classes[`${colorClass}N${colI}`]}`}
                      style={value === ansVal ? {backgroundColor: getColor(colorClass, colI, 0.7225)} : (value === null || value === undefined) ? null : {}}
                      onClick={() => setVal(ansVal)}
                      onMouseOver={() => setHover(i)}
                    >
                      {i > mid || (even && i === mid) ? "+" : null}{!even ? i - mid : i >= mid ? i - mid  + 1 : i - mid}
                      {(!saving || saving?.[0] - 1 !== i) ? null :
                        <div className={classes.loadingWrap}>
                          <LoadingCircle size={"font"} className={classes.loader} />
                        </div>
                      }
                    </Button>
                  }
                )}
              </ToolbarButtonGroup>
            </td>
          </tr>
          <tr className={classes.optionsLabels}>
            <td id={"labelMin"}>{labelMin}</td>
            {new Array(mid - 1).fill(0).map((_, i) => <td key={-i}/>)}
            {even ? null : <td id={"labelMid"} className={classes.midTd}>{labelMid === labelMax ? null : labelMid}</td>}
            {new Array(mid - 1).fill(0).map((_, i) => <td key={i}/>)}
            <td id={"labelMax"}>{labelMax}</td>
          </tr>
          </tbody>
        </table>
      </div>
    </div>;

  return (!slideDirection ? body :
      <Slide in={slideIn} direction={slideDirection} unmountOnExit>
        {body}
      </Slide>
  );
}

export default withStyles(styles)(AnswerSelect);




